import { Link } from "react-router-dom";
import  "./footer.css";
import { APPNAME } from "./util/api";

export default function Footer() {
    return (
        <footer className="modern-footer">
            <div className="footer-wrapper">

                {/* Left section */}
                <div className="footer-brand">
                    <h3>{APPNAME}</h3>
                    <p>
                        © {new Date().getFullYear()} <br />
                        All rights reserved.
                    </p>
                </div>

                {/* Right section */}
                <div className="footer-links">
                    <Link to="">Privacy Policy</Link>
                    <Link to="">Legal Notice</Link>
                    <Link to="">Terms of Service</Link>
                </div>

            </div>

            {/* Bottom strip */}
            <div className="footer-bottom">
                <span>
                    Built with care by
                    <Link to="/" target="_blank" rel="noreferrer">{APPNAME}</Link>
                </span>
            </div>
        </footer>
    );
}
